<template>
	<el-dialog title="打印条码" :visible.sync="visible" :before-close='printCodeStateClose' width="1600px" :close-on-click-modal="false">
		<!-- 主功能区 -->
		<noscript>
			<iframe sandbox="allow-scripts allow-same-origin" ref="ifrm" id="ifrm" :src="srcData" width="0" height="0"></iframe>
		</noscript>
		<div class="btnView">
			<el-button @click="handleAllClick" size="small">全选</el-button>
		</div>
		<template v-for="(item,index) in printArr">
			<div :id="'page'+index" :key="index">
				<div class="storeName" @click="handleStoreClick(index)">
					<div>
						<span>采购门店:{{item.companyInfo.shop_name}}</span>
						<i class="el-icon-caret-bottom" v-if="item.isShow" style="color: #1890FF;"></i>
						<i class="el-icon-caret-top" v-else style="color: #1890FF;"></i>
					</div>
				</div>
				<!-- 商品类 -->
				<div class="shopClass" v-if="item.procureGoodsList.shop.shops.length > 0 && item.isShow" >
					<div class="comH2" @click="handleStoreZLClick(index,1)">
						<div>商品类</div>
						<i class="el-icon-caret-bottom" v-if="item.procureGoodsList.shop.isShow"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="item.procureGoodsList.shop.isShow">
						<el-table :ref="'shopTable'+index" :data="item.procureGoodsList.shop.shops" tooltip-effect="dark" @selection-change="handleSelectShop(arguments[0],index)">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="goods.title" label="商品名称" />
							<el-table-column :key="2" prop="goods.brand" label="品牌" align="center" />
							<el-table-column :key="3" prop="supplier_name" label="供应商" align="center" />
							<el-table-column :key="4" prop="goods.sku_value" label="规格" align="center" width="120" />
							<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
							<el-table-column :key="6" prop="validation_data.paid_count" label="实收数量" align="center" />
							<el-table-column :key="7" prop="validation_data.giving_count" label="赠品数量" align="center" />
							<el-table-column :key="12" prop="distributions_list[0].distribution_count" label="分拨数量" align="center" />
							<el-table-column :key="8" label="总计数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data.paid_count+scope.row.validation_data.giving_count}}</span> 
								</template>
							</el-table-column>
							<el-table-column :key="9" prop="validation_data.cost_price" label="成本价" align="center" />
							<el-table-column :key="10" prop="procure_goods_remark" label="有效期" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="goods.times" label="使用次数" align="center" />
						</el-table>
					</div>
				</div>
				<!-- 医疗类 -->
				<div class="shopClass" v-if="item.procureGoodsList.drug.drugs.length > 0 && item.isShow">
					<div class="comH2" @click="handleStoreZLClick(index,2)">
						<div>医疗类</div>
						<i class="el-icon-caret-bottom" v-if="item.procureGoodsList.drug.isShow"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="item.procureGoodsList.drug.isShow">
						<el-table :ref="'drugTable'+index" :data="item.procureGoodsList.drug.drugs" tooltip-effect="dark" @selection-change="handleSelectDrug(arguments[0],index)">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="goods.title" label="商品名称" />
							<el-table-column :key="2" prop="goods.brand" label="品牌" align="center" />
							<el-table-column :key="3" prop="supplier_name" label="供应商" align="center" />
							<el-table-column :key="4" prop="goods.sku_value" label="规格" align="center" width="120" />
							<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
							<el-table-column :key="6" prop="validation_data.paid_count" label="实收数量" align="center" />
							<el-table-column :key="7" prop="validation_data.giving_count" label="赠品数量" align="center" />
							<el-table-column :key="12" prop="distributions_list[0].distribution_count" label="分拨数量" align="center" />
							<el-table-column :key="8" label="总计数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data.paid_count+scope.row.validation_data.giving_count}}</span> 
								</template>
							</el-table-column>
							<el-table-column :key="9" prop="validation_data.cost_price" label="成本价" align="center" />
							<el-table-column :key="10" prop="procure_goods_remark" label="有效期" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="goods.times" label="使用次数" align="center" />
						</el-table>
					</div>
				</div>
				<!-- 耗材类 -->
				<div class="shopClass" v-if="item.procureGoodsList.haocai.haocais.length > 0 && item.isShow">
					<div class="comH2" @click="handleStoreZLClick(index,3)">
						<div>耗材类</div>
						<i class="el-icon-caret-bottom" v-if="item.procureGoodsList.haocai.isShow"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="item.procureGoodsList.haocai.isShow">
						<el-table :ref="'haocaiTable'+index" :data="item.procureGoodsList.haocai.haocais" tooltip-effect="dark" @selection-change="handleSelectHaocai(arguments[0],index)">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="goods.title" label="商品名称" />
							<el-table-column :key="2" prop="goods.brand" label="品牌" align="center">
								<template>
									<span>--</span>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="supplier_name" label="供应商" align="center" />
							<el-table-column :key="4" prop="goods.sku_value" label="规格" align="center" width="120">
								<template>
									<span>--</span>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
							<el-table-column :key="6" prop="validation_data.paid_count" label="实收数量" align="center" />
							<el-table-column :key="7" prop="validation_data.giving_count" label="赠品数量" align="center" />
							<el-table-column :key="12" prop="distributions_list[0].distribution_count" label="分拨数量" align="center" />
							<el-table-column :key="8" label="总计数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data.paid_count+scope.row.validation_data.giving_count}}</span> 
								</template>
							</el-table-column>
							<el-table-column :key="9" prop="validation_data.cost_price" label="成本价" align="center" />
							<el-table-column :key="10" prop="procure_goods_remark" label="有效期" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="goods.times" label="使用次数" align="center" />
						</el-table>
					</div>
				</div>
			</div>
		</template>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleAllClick">全选</el-button>
			<el-button type="primary" @click="handlePrintCodeClick">打 印</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import {
		printCode
	} from '@/api/purchaseApi.js'
	import {
		// print,
		
	} from '@/api/stockApi.js'
	import printJs from "../util/print.js"
	export default {
		props: {
			printCodeState: { //显示状态
				default: false
			},
			id:{
				default: ''
			},
			printCodeData:{
				default:{}
			}
		},
		data() {
			return {
				visible: true,
				printArr:[],  //重构传递属性
				subArr:[],  //提交数据
				srcData:'',
			};
		},
		created() {
			console.log('打码商品',this.printCodeData)
			let printArr = [...this.printCodeData];
			let arr = []
			//过滤没有商品或者药品门店
			for(let i = 0;i<printArr.length;i++){
				//筛选没有商品门店
				let count = (printArr[i].procureGoodsList.shop.shops.length + printArr[i].procureGoodsList.drug.drugs.length + printArr[i].procureGoodsList.haocai.haocais.length);
				// console.log(count)
				if(count != 0){
					arr[i] = printArr[i]
				}
			}
			this.printArr = arr.filter(item => item);
			console.log('原始数据',this.printArr)
			
			//创建空数据
			let codeArr = [...this.printArr]
			let subArr = [];
			for(let j =0; j<codeArr.length;j++){
				subArr[j] = {};
				subArr[j].companyInfo = codeArr[j].companyInfo;
				subArr[j].shop = [];
				subArr[j].drug = [];
				subArr[j].haocai = [];
			}
			this.subArr = [...subArr];
			console.log('初始化数据',this.subArr)
			console.log(this.$refs.shopTable0)
		},
		mounted() {
			
		},
		watch: {
			// 监视状态发生改变
			printCodeState() {
				this.visible = this.printCodeState;
			},
		},
		methods: {
			// 全选
			handleAllClick(){
				for(let m = 0;m<this.printArr.length;m++){
					if(this.printArr[m].procureGoodsList.drug.drugs.length > 0){
						for(let n =0;n<this.printArr[m].procureGoodsList.drug.drugs.length;n++){
							let $table1 = this.$refs['drugTable'+m][0];
							$table1.toggleRowSelection(this.printArr[m].procureGoodsList.drug.drugs[n],true)
						}
					}
					if(this.printArr[m].procureGoodsList.shop.shops.length > 0){
						for(let k =0;k<this.printArr[m].procureGoodsList.shop.shops.length;k++){
							let $table2 = this.$refs['shopTable'+m][0];
							$table2.toggleRowSelection(this.printArr[m].procureGoodsList.shop.shops[k],true)
						}
					}
					if(this.printArr[m].procureGoodsList.haocai.haocais.length > 0){
						for(let j =0;j<this.printArr[m].procureGoodsList.haocai.haocais.length;j++){
							let $table3 = this.$refs['haocaiTable'+m][0];
							$table3.toggleRowSelection(this.printArr[m].procureGoodsList.haocai.haocais[j],true)
						}
					}
				}
			},
			//打码按钮
			handlePrintCodeClick(){
				console.log('提交数据',this.subArr)
				let goodsArr = [...this.subArr];
				let goodsCount = 0;
				//获取所有商品数量
				let addGoodsArr = [];
				for(let i = 0;i<goodsArr.length;i++){
					goodsCount += (goodsArr[i].shop.length + goodsArr[i].drug.length + goodsArr[i].haocai.length);
					addGoodsArr[i] = {};
					addGoodsArr[i].companyInfo = goodsArr[i].companyInfo;
					addGoodsArr[i].goods = [];
					addGoodsArr[i].goods = goodsArr[i].shop.concat(goodsArr[i].drug).concat(goodsArr[i].haocai)
				}
				console.log('选择商品数量',goodsCount,addGoodsArr)
				if(goodsCount == 0){
					this.$message({
						message:'请选择需要打码商品',
						type:'warning'
					})
					return
				}
				let shop_print_list = [];
				for(let m = 0;m< addGoodsArr.length;m++){
					for(let n = 0; n< addGoodsArr[m].goods.length;n++){
						let shopPrintCodeParam = {
							company_info : addGoodsArr[m].companyInfo,
							procure_goods_id: addGoodsArr[m].goods[n].procure_goods_id
						}
						shop_print_list.push(shopPrintCodeParam)
					}
				}
				console.log('上传数据',shop_print_list)
				let parmars = {
					id:this.id,
					shop_print_list:shop_print_list
				} 
				printCode(parmars).then((res)=>{
					if(res.code == 0){
						this.$message({
							message:'开始打码',
							type:'success'
						})
						console.log(res.data.customCodesList)
						let printArr = [];
						let item = res.data.customCodesList;
						for(let k = 0;k< item.length;k++){
							printArr[k] = {
								code: Number(item[k].code),
								name: item[k].name,
								sku: item[k].totaltimes > 1 ? `${item[k].sku}/${item[k].totaltimes}次` : item[k].sku,
								unit: item[k].unit,
								price: item[k].pprice,
							}
						}
					
						
						let params = {
							bar_codes: printArr
						};
						printJs.printTicketBarCode(params.bar_codes).then(res=>{
							this.$store.commit("set_printUrl",res.msg)
						})
						// print(JSON.stringify(params)).then(data => {
						// 	if (data.url != "") {
						// 		this.srcData = `ChuLinPrint:${data.url}`;
						// 	}
						// });
						
					}
				})
			},
			//选择商品列表
			handleSelectShop(val,index){
				console.log(val,index)
				this.subArr[index].shop = val;
			},
			//选择药品列表
			handleSelectDrug(val,index){
				console.log(val,index)
				this.subArr[index].drug = val;
			},
			//选择耗材列表
			handleSelectHaocai(val,index){
				console.log(val,index)
				this.subArr[index].haocai = val;
			},
			//向父组件发射关闭弹框
			printCodeStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
			//显示或者隐藏对应门店
			handleStoreClick(index){
				console.log(index)
				let stores = this.printArr;
				stores[index].isShow = !stores[index].isShow;
				this.stores = stores
				this.$set(this.stores,index,this.stores[index])
				console.log(stores)
			},
			//显示或者隐藏对应门店的子类
			handleStoreZLClick(index,type){
				console.log(index,type)
				let stores = this.printArr;
				if(type == 1){
					stores[index].procureGoodsList.shop.isShow = !stores[index].procureGoodsList.shop.isShow;
				}else if(type == 2){
					stores[index].procureGoodsList.drug.isShow = !stores[index].procureGoodsList.drug.isShow;
				}else if(type == 3){
					stores[index].procureGoodsList.haocai.isShow = !stores[index].procureGoodsList.haocai.isShow;
				}
				this.stores = stores
				this.$set(this.stores,index,this.stores[index])
			},
			//重构日期
			FormatDate(item){
				let time = new Date(item*1000) 
				let year = time.getFullYear()
				let month = time.getMonth() + 1<10?'0'+(time.getMonth() + 1):time.getMonth() + 1
				let date = time.getDate()<10?'0'+time.getDate():time.getDate()
				return year+'-'+month+'-'+date
			},
		}
	};
</script>
<style lang="scss" scoped>
	.storeName{
		font-size: 18px;
		color: #1890FF;
		line-height: 40px;
		font-weight: bold;
		div:nth-of-type(1){
			margin-left: 20px;
		}
	}
	.btnView{
		display: flex;
		justify-content: flex-end;
	}
	.comH2 {
		line-height: 30px;
		font-size: 16px;
		display: flex;
		align-items: center;
	}
	
	.comH2 div {
		margin-left: 20px;
		margin-right: 6px;
		font-weight: bold;
	}
	
	.comH2 img {
		width: 16px;
		height: 16px;
		background: red;
	}
</style>
